export const isValidImage = (file: File) => {
  const maxFileSize = 8000000; // 8mb
  if (file) {
    return file.size < maxFileSize && file.type.includes('image');
  } else {
    return false;
  }
};
